export default {
  methods: {
    getDayName(date) {
      const dayNames = [
                    this.$t('global.sundayshort'),
                    this.$t('global.mondayshort'),
                    this.$t('global.tuesdayshort'),
                    this.$t('global.wednesdayshort'),
                    this.$t('global.thursdayshort'),
                    this.$t('global.fridayshort'),
                    this.$t('global.saturdayshort'),
                  ];
      const dayIndex = new Date(date).getDay();
      return dayNames[dayIndex];
    },

    getDayNumber(date) {
      return new Date(date).getDate();
    },

    getDateByIndexAndStartDate(index, startDate) {
      const date = new Date(startDate);
      date.setDate(date.getDate() + index);
      return date;
    },

    getSQLDateByIndexAndStartDate(index, startDate) {
      const date = new Date(startDate);
      date.setDate(date.getDate() + index);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    getSQLDateFromDate(date) {
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, '0');
      const day = String(newDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  }
};
